module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Software für Unternehmen","short_name":"SfU","start_url":"/","background_color":"#4E00B3","theme_color":"#4E00B3","display":"minimal-ui","icon":"src/images/sfu.png","icons":[{"src":"/favicons/sfu.png","sizes":"150x100","type":"image/png"}]},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
